if (!customElements.get('guest-rewards-nudge-group')) {
  customElements.define(
    'guest-rewards-nudge-group',
    class GuestRewardsNudgeGroup extends HTMLElement {
      connectedCallback() {
        this.earn = this.querySelector('[data-purchase-type="one_time"]');
        this.subscription = this.querySelector('[data-purchase-type="subscription"]');
        this.handleChange = (event) => this.toggle(Boolean(event.detail && event.detail.value));
        document.addEventListener('selling-plan:change', this.handleChange);
        this.toggle(this.isSubscriptionSelected());
      }

      disconnectedCallback() {
        document.removeEventListener('selling-plan:change', this.handleChange);
      }

      isSubscriptionSelected() {
        const checked = document.querySelector('subscription-module input[type="radio"]:checked');
        return checked ? checked.dataset.radioType === 'selling_plan' : false;
      }

      toggle(isSubscription) {
        if (!this.earn || !this.subscription) return;
        this.earn.hidden = isSubscription;
        this.subscription.hidden = !isSubscription;
      }
    }
  );
}
